export const OTP = require('./otp.webp')
export const LOCATION_KYC_IMAGE = require('./location-kyc.webp')
export const PENDING_AMOUNT_IMAGE = require('./pending-amount.webp')
export const DEHAAT_LOGO = require('./dehaat-logo.png')
export const TRACTOR_IMAGE = require('./tractor.png')
export const DC_ICON = require('./dc_icon.webp')
export const DEMO_MATERIAL_TILE_ICON = require('./demo_material_tile_icon.webp')
export const PRICE_CHANGE_TILE_ICON = require('./price_change_tile_icon.webp')
